import { Injectable } from '@angular/core';
import { IdiomaService } from "./idioma.service";
import { Observable, map, catchError, of } from "rxjs";
import { TraducoesTags } from "../interfaces/tag.interface";


@Injectable({
  providedIn: 'root'
})
export class TraducaoService {

  private traducoes: { [key in 'pt-br' | 'en' | 'es']: { [key: string]: string } } = {
  'pt-br': {
    topo: 'Topo',
    home: 'Home',
    formacao: 'Formação',
    idiomas: 'Idiomas',
    extraCurso: 'Extra',
    cursos: 'Cursos IT',
    superiorAtual: 'Análise e Desenvolvimento de Sistemas - Estácio - Cursando - 01/24 à 06/26',
    superiorAnterior: 'Psicologia - Faculdades de Guarulhos - Finalizado - 01/04 à 12/08',
    ingles: 'Inglês',
    inglesNivel: 'Inglês: Intermediário (B1)',
    espanhol: 'Espanhol',
    espanholNivel: 'Espanhol: Fluente (C1)',
    portugues: 'Português',
    extra1: 'Cenografia e Ambientação - CC San Martín/ARG - Concluído - 70h',
    extra2: 'Fotografia e Edição Básica - CC San Martín/ARG - Concluído - 70h',
    extra3: 'Desenho de Cenografia - Inst. Saulo Benavente/ARG - Concluído - 120h',
    extra4: 'Introdução a Direção de Arte - Cistik Oficina/ARG - Concluído - 16h',
    extra5: 'Desenho de Croquis - Centro FD - Concluído - 50h',
    extra6: 'Introdução a Roteiro Audiovisual - ACM - Concluído - 36h',
  },
  'en': {
    topo: 'Top',
    home: 'Home',
    formacao: 'Education',
    idiomas: 'Languages',
    extraCurso: 'Extra Courses',
    cursos: 'IT Courses',
    superiorAtual: 'Systems Analysis and Development - Estácio - In Progress - 01/24 to 06/26',
    superiorAnterior: 'Psychology - Faculdades de Guarulhos - Completed - 01/04 to 12/08',
    ingles: 'English',
    inglesNivel: 'English: Intermediate (B1)',
    espanhol: 'Spanish',
    espanholNivel: 'Spanish: Fluent (C1)',
    portugues: 'Portuguese',
    extra1: 'Scenography and Set Design - CC San Martín/ARG - Completed - 70h',
    extra2: 'Photography and Basic Editing - CC San Martín/ARG - Completed - 70h',
    extra3: 'Set Design Drawing - Inst. Saulo Benavente/ARG - Completed - 120h',
    extra4: 'Introduction to Art Direction - Cistik Oficina/ARG - Completed - 16h',
    extra5: 'Sketch Drawing - Centro FD - Completed - 50 hours',
    extra6: 'Introduction to Audiovisual Scriptwriting - ACM - Completed - 36h',
  },
  'es': {
    topo: 'Arriba',
    home: 'Inicio',
    formacao: 'Formación',
    idiomas: 'Idiomas',
    extraCurso: 'Extra',
    cursos: 'Cursos IT',
    superiorAtual: 'Análisis y Desarrollo de Sistemas - Estácio - En curso - 01/24 a 06/26',
    superiorAnterior: 'Psicología - Faculdades de Guarulhos - Finalizado - 01/04 a 12/08',
    ingles: 'Inglés',
    inglesNivel: 'Inglés: Intermedio (B1)',
    espanhol: 'Español',
    espanholNivel: 'Español: Fluido (C1)',
    portugues: 'Portugués',
    extra1: 'Escenografía y Ambientación - CC San Martín/ARG - Concluido - 70h',
    extra2: 'Fotografía y Edición Básica - CC San Martín/ARG - Concluido - 70h',
    extra3: 'Dibujo de Escenografía - Inst. Saulo Benavente/ARG - Concluido - 120h',
    extra4: 'Introducción a la Dirección de Arte - Cistik Oficina/ARG - Concluido - 16h',
    extra5: 'Dibujo de Croquis - Centro FD - Concluido - 50 horas',
    extra6: 'Introducción a la Escritura de Guiones Audiovisuales - ACM - Concluido - 36h',
  }
};

  private traducoesTags: { [idioma: string]: TraducoesTags } = {
    'pt-br': {
      html: 'HTML',
      css: 'CSS',
      js: 'JavaScript',
      angular: 'Angular',
      typescript: 'TypeScript',
      git: 'Git',
      outros: 'Outros',
      uxui: 'UX/UI',
      vue: 'Vue',
    },
    'en': {
      html: 'HTML',
      css: 'CSS',
      js: 'JavaScript',
      angular: 'Angular',
      typescript: 'TypeScript',
      git: 'Git',
      outros: 'Others',
      uxui: 'UX/UI',
      vue: 'Vue',
    },
    'es': {
      html: 'HTML',
      css: 'CSS',
      js: 'JavaScript',
      angular: 'Angular',
      typescript: 'TypeScript',
      git: 'Git',
      outros: 'Otros',
      uxui: 'UX/UI',
      vue: 'Vue',
    }
  }

  constructor(private idiomaService: IdiomaService) {}

  obterTraducao(key: string): Observable<string> {
    return this.idiomaService.idioma$.pipe(
      map(idioma => {
        const traducao: string = this.traducoes[idioma as 'pt-br' | 'en' | 'es']?.[key];
        return traducao || key;
      }),
      catchError(err => {
        console.error('Erro ao obter tradução:', err);
        return of(key);
      })
    );
  }

  obterTraducaoTags(idioma: 'pt-br' | 'en' | 'es'): TraducoesTags {
    return this.traducoesTags[idioma];
  }
}
